import Phaser from "phaser";
import SceneKeys from "../constants/scene-keys";

class TitleScreen extends Phaser.Scene {
  constructor() {
    super(SceneKeys.TITLE_SCREEN);
  }

  preload() {
    this.load.image('titlescreen', 'assets/titlescreen.png');
  }

  create() {
    const { width, height } = this.scale;
    this.add.image(width/2, height/2, 'titlescreen');
    
    this.createStartButton();

    this.input.keyboard.once('keydown-SPACE', () => {
      this.scene.start(SceneKeys.GAME);
    });
  }

  createStartButton() {
    const { width, height } = this.scale;

    // use arrow keys to move the player instructions and press space to open a box
    const instructions = this.add.text(width/2, height/2 + 135, 'Use arrow keys to move\nthe player and press \nspace to open a box', {
      fontSize: 14,
      fontFamily: '"Press Start 2P"',
      align: 'center',
      color: '#000',
      backgroundColor: '#f8cd60',
      padding: 10,
    });

    instructions.setOrigin(0.5, 0.5);

    const playButton = this.add.text(width/2, height/2, 'START GAME', {
      fontSize: 24,
      fontFamily: '"Press Start 2P"',
      color: '#000',
      backgroundColor: '#fff',
      padding: 10,
    });

    playButton.setOrigin(0.5, -1).setInteractive();

    playButton.on('pointerover', () => {
      playButton.setStyle({ backgroundColor: '#A865C9' });
    });

    playButton.on('pointerout', () => {
      playButton.setStyle({ backgroundColor: '#fff' });
    });

    playButton.on('pointerdown', () => {
      this.scene.start(SceneKeys.GAME);
    });
  }
}

export default TitleScreen;